var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulAlbums(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.77 26c1.015 0 1.807-.288 2.376-.864.57-.577.854-1.433.854-2.57v-11.14c0-1.137-.298-1.993-.895-2.57-.596-.576-1.479-.864-2.648-.864h-9.293c-.38 0-.7-.05-.964-.149a3.126 3.126 0 0 1-.837-.504l-.65-.526c-.38-.305-.74-.517-1.08-.636-.341-.118-.79-.177-1.348-.177H7.16c-1 0-1.776.282-2.33.847C4.278 7.412 4 8.251 4 9.366v13.2c0 1.144.298 2.003.895 2.575.596.573 1.475.859 2.637.859H24.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.476 22.35c.79 0 1.43-.253 1.922-.756.492-.504.738-1.145.738-1.924v-3.652c0-.198.023-.332.07-.4.046-.069.127-.115.244-.138l2.579-.618c.263-.06.445-.143.546-.246.1-.103.15-.315.15-.635v-2.13c0-.213-.052-.364-.156-.452-.105-.088-.304-.093-.599-.017l-3.218.778c-.27.069-.449.155-.534.258-.085.103-.128.322-.128.658v4.797c0 .237-.029.395-.087.475-.058.08-.226.158-.505.235l-1 .263a3.064 3.064 0 0 0-1.306.647c-.36.309-.54.73-.54 1.265 0 .458.164.838.493 1.139.33.302.773.452 1.33.452z",
    fill: "#FFF",
    opacity: 0.84
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulAlbums);
export default __webpack_public_path__ + "static/media/icons-colorful-albums.aac1d6c6.svg";
export { ForwardRef as ReactComponent };